import axios from "axios";

import environment from "../environment";
import { refreshTokenInterceptor, responseSuccessInterceptor, responseRefreshTokenErrorInterceptor } from './interceptors';

const RefreshTokenApi = axios.create({
   baseURL: environment.api
});

RefreshTokenApi.interceptors.request.use(refreshTokenInterceptor);
RefreshTokenApi.interceptors.response.use(responseSuccessInterceptor, responseRefreshTokenErrorInterceptor);

export default RefreshTokenApi;